import { onDocumentEvent } from '@app/utils/domHelpers'

const toggleStaffAccess = (e) => {
  const staffAccess = e.target.checked

  const togglableElement = document.querySelector(
    '[data-behaviour="user-edit-visible-for-staff"]'
  )
  togglableElement.style.display = staffAccess ? 'block' : 'none'
}

const toggleSsoEnabled = (e) => {
  const ssoEnabled = e.target.checked

  const togglableElement1 = document.querySelector(
    '[data-behaviour="user-create-sso-entity"]'
  )

  const togglableElement2 = document.querySelector(
    '[data-behaviour="sso-disabled-hint"]'
  )

  if (ssoEnabled) {
    togglableElement1.style.display = 'block'
    togglableElement2.style.display = 'none'
  } else {
    togglableElement1.style.display = 'none'
    togglableElement2.style.display = 'block'
  }
}

const toggleEmailWrapper = (e) => {
  const hintEl = document
    .querySelector('[data-target="send-welcome-email-wrapper"]')
    .parentElement.parentElement.querySelector('.sf-dim-el')

  const prompt = document.querySelector(
    '[data-target="send-welcome-email-wrapper"] span'
  )

  if (e.target.value) {
    hintEl.style.display = 'none'
    prompt.textContent = I18n.t('user.send_welcome_mail')
  } else {
    hintEl.style.display = 'block'
    prompt.textContent = I18n.t(
      'activerecord.attributes.user.send_welcome_mail'
    )
  }
}

const toggleAdminAccess = (e) => {
  const adminAccess = e.target.checked

  const companyCreationAccessCheckbox = document.getElementById(
    'company-creation-access-checkbox'
  )

  if (adminAccess) {
    companyCreationAccessCheckbox.style.display = 'none'
  } else {
    companyCreationAccessCheckbox.style.display = 'block'
  }
}

export default () => {
  const removeAccessVisibilityListeners = onDocumentEvent(
    document,
    'change',
    '[data-behaviour="user-edit-staff-access"]',
    toggleStaffAccess
  )

  const removeSsoListener = onDocumentEvent(
    document,
    'change',
    '[data-behaviour="user-create-sso-entity"]',
    toggleEmailWrapper
  )

  const removeSsoEnabledListener = onDocumentEvent(
    document,
    'change',
    '[data-behaviour="enable-sso-settings"]',
    toggleSsoEnabled
  )

  const removeAdminAccessEnabled = onDocumentEvent(
    document,
    'change',
    '[data-behaviour="enable-admin-access"]',
    toggleAdminAccess
  )

  return () => {
    removeAccessVisibilityListeners()
    removeSsoListener()
    removeSsoEnabledListener()
    removeAdminAccessEnabled()
  }
}
